import { Subject } from 'rxjs';
import { DataAccessConfiguration } from './data-access-configuration';

let listener: () => void = function () {
  // No op. Purposely do nothing.
};

export function signalJwtAuthError() {
  listener();
}

export const jwtRefreshedSignal = new Subject<boolean>();

export class DataAccessEnvironment {
  private jwtBacking = '';

  authToken = '';
  fleetJwt = '';

  set jwt(value: string) {
    this.jwtBacking = value;
    jwtRefreshedSignal.next(true);
  }
  get jwt() {
    return this.jwtBacking;
  }

  refreshToken = '';

  configuration: DataAccessConfiguration = {
    showZodErrorsInConsole: false,
  };

  onJwtAuthError(callback: () => void) {
    listener = callback;
  }
}

export const dataAccessEnvironment = new DataAccessEnvironment();
